import { api } from '@/modules/apiv2';
import { convertStringtoAPIDate } from '@/mixins.js';

export default {
  state: {
    event: null,
    events: [],
    srcEvents: [],
    nonRmsEvents: [],
    trainingEvent: null,
  },

  getters: {
    event(state) {
      return state.event;
    },

    events(state) {
      return state.events;
    },

    srcEvents(state) {
      return state.srcEvents;
    },

    nonRmsEvents(state) {
      return state.nonRmsEvents;
    },

    trainingEvent(state) {
      return state.trainingEvent;
    },
  },

  mutations: {
    setEvent(state, event) {
      if (event) {
        state.event = event;
      }
    },

    setEvents(state, events) {
      if (events) {
        state.events = events;
      }
    },

    setSrcEvents(state, events) {
      if (events) {
        state.srcEvents = events;
      }
    },

    setNonRmsEvents(state, events) {
      if (events) {
        state.nonRmsEvents = events;
      }
    },

    setTrainingEvent(state, trainingEvent) {
      if (trainingEvent) {
        state.trainingEvent = trainingEvent;
      }
    },
  },

  actions: {
    getEvent({ commit, getters }, eventId) {
      const endpoint = getters.eventsEndpoint;

      return api
        .get(`${endpoint}/${eventId}`)
        .then((data) => {
          commit('setEvent', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    deleteEvent({ getters }, data) {
      const endpoint = getters.devicesEndpoint;

      return api
        .delete(`${endpoint}/${data.deviceid}/events/${data.eventid}`)
        .then((data) => {
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    createTrainingEvent({ getters }, data) {
      const endpoint = getters.eventsEndpoint;
      return api
        .post(endpoint, data)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          throw error;
        });
    },

    getEvents({ commit, getters }, params) {
      if (!getters.currentUserIsAdmin) {
        // Current user is not an admin, so we cannot fetch events with this api
        return;
      }
      const endpoint = getters.eventsEndpoint;
      let queryParams = [];

      if (params.startDate) {
        let startDate = convertStringtoAPIDate(params.startDate);
        queryParams.push(`Start=${startDate}`);
      }

      if (params.endDate) {
        let endDate = convertStringtoAPIDate(params.endDate);
        queryParams.push(`End=${endDate}`);
      }

      let limit = params.limit || 100;
      queryParams.push(`Limit=${limit}`);

      if (params.token) {
        queryParams.push(`ContinuationToken=${params.token}`);
      }

      let filters = params.filters
        .filter((filter) => {
          // Always pass isMaintenanceModeEvent regardless of value
          if (Object.keys(filter)[0] === 'isMaintenanceModeEvent') {
            return true;
          }

          // Always pass isNuisanceAlert regardless of value
          if (Object.keys(filter)[0] === 'isNuisanceAlert') {
            return true;
          }

          // Only send other parameters
          // if a value exists
          return Object.values(filter)[0];
        })
        .map((filter) => {
          return `${Object.keys(filter)[0]}=${Object.values(filter)[0]}`;
        })
        .concat(queryParams)
        .join('&');

      return api
        .get(`${endpoint}?${filters}`)
        .then((data) => {
          commit('setEvents', data);

          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    getNonRmsEvents({ commit, getters }, { token }) {
      const endpoint = getters.eventsEndpoint;
      let queryParams = [];

      const eventsLimit = 100;
      queryParams.push(`Limit=${eventsLimit}`);

      if (token) {
        queryParams.push(`ContinuationToken=${token}`);
      }

      // Getting non-RMS events, so set OtherType to banner, email, and export
      queryParams.push(`OtherType=${['banner', 'email', 'export']}`);

      let filters = queryParams.join('&');

      return api.get(`${endpoint}?${filters}`).then((data) => {
        commit('setNonRmsEvents', data);

        return data;
      });
    },

    getSrcEvents({ commit, getters }) {
      const endpoint = getters.eventsEndpoint;

      return api
        .get(`${endpoint}?Limit=100&OtherType=banner&Src`)
        .then((data) => {
          commit('setSrcEvents', data);

          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    createMessage({ getters }, data) {
      const endpoint = getters.eventsEndpoint;

      return api
        .post(endpoint, data)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          throw error;
        });
    },
  },
};
